import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    PREMIUM_SUBSCRIPTION_HALFYEARLY_PRICE_WITH_VAT,
    PREMIUM_SUBSCRIPTION_MONTHLY_PRICE_WITH_VAT,
    PREMIUM_SUBSCRIPTION_YEARLY_PRICE_WITH_VAT,
} from '@app/common/src/constants/premium-subscription';
import { LookupKeyEnum } from '../../../../defs/api';
import { getBillingPeriodByLookupKey } from '../../../../models/functions/billing-period';
import { cn } from '../../../../utils/tailwind';

type SignupSelectedPlanBannerProps = {
    lookupKey: LookupKeyEnum;
};

const PRICE_BY_PERIOD = {
    monthly: PREMIUM_SUBSCRIPTION_MONTHLY_PRICE_WITH_VAT,
    halfyearly: PREMIUM_SUBSCRIPTION_HALFYEARLY_PRICE_WITH_VAT,
    yearly: PREMIUM_SUBSCRIPTION_YEARLY_PRICE_WITH_VAT,
};

export const SignupSelectedPlanBanner: React.FC<SignupSelectedPlanBannerProps> = ({ lookupKey }) => {
    const { t } = useTranslation();
    const period = getBillingPeriodByLookupKey(lookupKey);

    if (!period) {
        return null;
    }

    return (
        <div
            className={cn(
                'relative mb-[2.4rem] overflow-hidden rounded-large border border-solid border-brand-primary/[0.14]',
                'bg-neutral-white bg-[linear-gradient(135deg,rgb(var(--color-primary-rgb)_/_0.1)_0%,rgb(var(--color-blue-rgb)_/_0.05)_60%,rgb(var(--color-secondary-rgb)_/_0.04)_100%)]',
                'px-medium py-[1.6rem] text-brand-secondary shadow-[0_0.8rem_2rem_rgb(var(--color-primary-rgb)_/_0.1)] sm:pr-[12rem]',
            )}
        >
            <div className="absolute inset-y-0 left-0 w-[0.3rem] [background:var(--gradient-primary)]" />
            <div className="flex flex-col gap-[0.4rem] pl-[0.4rem]">
                <div className="mb-[0.2rem] w-fit rounded-full px-[0.8rem] py-[0.2rem] text-[1.1rem] leading-[1.4rem] font-bold uppercase tracking-[0.08em] text-neutral-white [background:var(--gradient-primary)] sm:absolute sm:right-[1.2rem] sm:top-[1rem] sm:mb-0">
                    {t('dialogs.signUp.selectedPlan.badge')}
                </div>
                <div className="text-large leading-large font-bold">
                    {t(`dialogs.signUp.selectedPlan.title.${period}`)}
                </div>
                <div className="text-medium leading-medium text-text-muted">
                    {t('dialogs.signUp.selectedPlan.price', {
                        price: PRICE_BY_PERIOD[period],
                        period: t(`dialogs.signUp.selectedPlan.period.${period}`),
                    })}
                </div>
            </div>
        </div>
    );
};
